import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeT } from '../../../group_leader/helpers/i18n'
import { goToStep, STEPS } from '../../store/wizardSlice'

const t = makeT('group_leader.event_setup.header')

// The sr-only word per state. `active` is omitted -- aria-current="step" already says it.
const STATE_KEY = { done: 'completed', pending: 'needs_attention', future: 'not_started' }

const stepState = (step, currentStep, completedSteps) => {
  if (step === currentStep) { return 'active' }
  if (completedSteps.includes(step)) { return 'done' }
  return STEPS.indexOf(step) < STEPS.indexOf(currentStep) ? 'pending' : 'future'
}

const WizardHeader = () => {
  const dispatch = useDispatch()
  const { currentStep, completedSteps } = useSelector((state) => state.wizard)

  return (
    <div className="gl-event-setup-header">
      <ol className="gl-event-setup-step-list" aria-label={t('progress')}>
        {STEPS.map((step, idx) => {
          const state = stepState(step, currentStep, completedSteps)
          const isActive = state === 'active'
          const isDone = state === 'done'

          return (
            <li key={step} className={`gl-event-setup-step-item${isActive ? ' is-active' : ''}`}>
              <button
                type="button"
                className={`gl-event-setup-step-btn is-${state}`}
                onClick={() => dispatch(goToStep(step))}
                aria-current={isActive ? 'step' : undefined}
              >
                <span className="gl-event-setup-step-number" aria-hidden="true">
                  {isDone ? '✓' : idx + 1}
                </span>
                <span className={`gl-event-setup-step-label${isActive ? ' is-active' : ''}`}>
                  {t(`steps.${step}`)}
                </span>
                {/* The number/checkmark is aria-hidden, so without this a screen reader hears
                    five step names and cannot tell which are done (a11y checklist 7/8). */}
                {STATE_KEY[state] && (
                  <span className="sr-only">{t(`state.${STATE_KEY[state]}`)}</span>
                )}
              </button>
              {idx < STEPS.length - 1 && (
                <span className={`gl-event-setup-connector${isDone ? ' is-done' : ''}`} aria-hidden="true" />
              )}
            </li>
          )
        })}
      </ol>
    </div>
  )
}

export default WizardHeader
